'use client';
import React from 'react';
import styled from '@benzinga/themetron';
import { Future } from '@benzinga/commodities-manager';
import { FuturesTable } from './FuturesTable';

interface FuturesProps {
  category: string;
  futures?: Future[];
  link: string;
}

export const Futures: React.FC<FuturesProps> = ({ category, futures, link }) => {
  const filtered = futures ?? [];
  const limit = [...filtered].splice(0, 5);
  const [showAll, setShowAll] = React.useState<boolean>(false);
  const handleShowAll = React.useCallback(() => {
    setShowAll(!showAll);
  }, [showAll]);

  return (
    <FuturesWrapper>
      <h2>{category}</h2>
      <FuturesTable futures={showAll ? filtered : limit} link={link} />
      {!showAll && (
        <div className="see-all" onClick={handleShowAll}>
          See All {filtered.length} {category} Futures
        </div>
      )}
    </FuturesWrapper>
  );
};

const FuturesWrapper = styled.div`
  width: 100%;
  margin-bottom: 1rem;
  h2,
  .see-all {
    padding: 0.25rem 0.5rem;
  }
  .see-all {
    cursor: pointer;
  }
`;
